import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getUsersList = (usersData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_USERS_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/user/list`,
        usersData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_USERS_LIST_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "GET_USERS_LIST_FAILED",
          payload: data,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_USERS_LIST_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const getWebUsersList = (usersData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_WEB_USERS_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/user/list`,
        usersData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_WEB_USERS_LIST_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "GET_WEB_USERS_LIST_FAILED",
          payload: data,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_WEB_USERS_LIST_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const getAllUsers = (all = false, page = 1, limit = 10, signup_from) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_ALL_USERS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/user/all`,
        { all, page, limit, signup_from },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_ALL_USERS_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_ALL_USERS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_ALL_USERS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getKioskUsersList = (usersData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_KIOSK_USERS_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/user/list`,
        usersData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_KIOSK_USERS_LIST_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "GET_KIOSK_USERS_LIST_FAILED",
          payload: data,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_KIOSK_USERS_LIST_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const getUser = (usersData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_USER_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/user/view/${usersData}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_USER_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_USER_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_USER_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const updateUserSubscriptionStatus = (subscriptionData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_USER_SUBSCRIPTION_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/user/update-subscription-status`,
        subscriptionData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_USER_SUBSCRIPTION_SUCCESS", payload: data });
        // toast.success(data.message || "Subscription status updated successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_USER_SUBSCRIPTION_FAILED", payload: data });
        // toast.error(data.message || "Failed to update subscription status");
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_USER_SUBSCRIPTION_FAILED",
        payload: error?.response?.data?.message,
      });
      // toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const getBookingsList = (bookingData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_USER_BOOKINGS_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/user/list-by-user`,
        bookingData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_USER_BOOKINGS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_USER_BOOKINGS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_USER_BOOKINGS_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};